'use strict';

var $ = require('jquery');

$(function() {
	$('.back-forward-bar').css('display', 'flex');

	var lastScrollTop = 0;
	$(window).scroll(function(e) {
		var st = $(this).scrollTop();
		if (((st + window.innerHeight) < $(document).height() && st < lastScrollTop) || st <= 0) {
			$('.back-forward-bar').addClass('visible');
		}
		else {
			$('.back-forward-bar').removeClass('visible');
		}
		lastScrollTop = st;
	});
});